import React from "react";
import { Link, NavLink } from "react-router-dom";
import facebook from "../../Images/facebook.svg";
import linkedin from "../../Images/linkedin.svg";
import youtube from "../../Images/youtube.svg";
import GPSlogo from "../../Images/GPSDataViz_Logo_White-01.png";
import twitter from "../../Images/twitter.svg";

import "./Footer.css";

const Footer = () => {
  const [current, setCurrent] = React.useState("");
  const scrollToTarget = (ref) => {
    console.log(ref);
    if (ref === "/") {
      return window.scrollTo({ top: 0, behavior: "smooth" });
    }
    const section = document.getElementById(ref);

    section?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="componentContainer">
      <div className="footerwrapper">
        <div className="first">
          <img className="logo" src={GPSlogo} alt="header-logo" />
        </div>
        <div className="second">
          <h1>Company</h1>
          <ul>
            <li
              key="#about"
              onClick={() => {
                setCurrent("#about");
                scrollToTarget("#about");
              }}
              >
              <NavLink
                to="#about"
              >
                About Us
              </NavLink>
            </li>
            <li 
              key="#customer-success"
              onClick={() => {
              setCurrent("#customer-success");
              scrollToTarget("#customer-success");
            }}>
              {" "}
              <NavLink
                to="#customer-success"
              >Customer Success</NavLink>
            </li>
            <li
              key="#team"
              onClick={() => {
                setCurrent("#team");
                scrollToTarget("#team");
              }}
              >
              {" "}
              <NavLink
                to="#team"
              >
                The Team
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="third">
          <h1>Contact Us</h1>
          <Link>
            <p>Contact : info@whistleperformance.ai</p>
          </Link>
          <hr className="row" />
          <div className="links">
            {/* <Link>
              <img src={facebook} alt="facebook" />
            </Link> */}
            <Link
              to={{ pathname:"https://www.linkedin.com/company/gps-dataviz"}}
              target="_blank"
            >
              <img src={linkedin} alt="linkedin" />
            </Link>
            <Link to={{ pathname:"https://youtube.com/@gpsdataviz"}} target="_blank">
              <img src={youtube} alt="youtube" />
            </Link>
            <Link to={{ pathname:"https://twitter.com/GPSDataViz"}} target="_blank">
              <img src={twitter} alt="twitter" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
